// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3Odzn","col":"styles_col__1-O-t"};